'use client';

import { useEditableDotCMSPage } from '@dotcms/react';
import { formatLongDate } from '@/app/utils/date.utils';
import FeatureTimeline from '@/components/features/FeatureTimeline';
import FeatureScreenshot from '@/components/features/FeatureScreenshot';
import FeatureDetail from '@/app/features/[slug]/FeatureDetail';

export default function FeatureDetailContent({
    pageResponse,
    urlContentMap,
    allFeatures,
    currentSlug
}) {
    useEditableDotCMSPage(pageResponse);

    return (
        <div className="container mx-auto md:flex">
            <aside className="md:w-80 md:shrink-0">
                <FeatureTimeline features={allFeatures} currentSlug={currentSlug} />
            </aside>
            <div className="flex-1 px-4 py-8 md:px-10 md:py-12">
                <h1 className="mb-4 text-4xl font-bold">{urlContentMap.title}</h1>
                <p className="mb-8 text-sm text-gray-500">
                    {formatLongDate(urlContentMap.releaseDate)}
                </p>
                <FeatureScreenshot feature={urlContentMap} className="mt-4" />
                <FeatureDetail featureDescription={urlContentMap.featureDescription} />
            </div>
        </div>
    );
}
